import chroma from "chroma-js";

const hover = color => chroma.mix(color, "#000", 0.2);

// Primary Colors
const WHITE = "#fff";
const ORANGE = "#f99d1c";

const BLUE = "#3592b7";
const PASTEL_BLUE = "#383844"; //hover

const DARK_BLUE_1 = "#22232a"; //page background
const DARK_BLUE_2 = "#363845"; // table header background
const DARK_BLUE_3 = "#272930"; //common-nav background
const DARK_BLUE_4 = "#2a2b33"; //even
const DARK_BLUE_5 = "#2d2e39"; //odd

const LIGHT_GREY = "#adadad"; //font
const LIGHT_GREY_1 = "#d1d1d1";
const LIGHT_GREY_2 = "#a0a0a0";
const LIGHT_GREY_3 = "#b7b7b7";
const LIGHT_GREY_4 = "#3d3e4a";
const LIGHT_GREY_6 = "#ddd";

const DARK_GREY_1 = "#454545";

// Heatmap
const REQUESTS_START = DARK_BLUE_1;
const REQUESTS_END = BLUE;
const QUERIES_START = DARK_BLUE_1;
const QUERIES_END = "#e68417";
const REMOTE_START = DARK_BLUE_1;
const REMOTE_END = "#18af9f";
const CACHES_START = DARK_BLUE_1;
const CACHES_END = "#235a94";
const EXCEPTIONS_START = DARK_BLUE_1;
const EXCEPTIONS_END = "#ea4c3b";

export default {
  colors: {
    MAIN: BLUE,
    BACKGROUND: DARK_BLUE_1,
    REQUESTS_START,
    REQUESTS_END,
    REMOTE_START,
    REMOTE_END,
    QUERIES_START,
    QUERIES_END,
    CACHES_START,
    CACHES_END,
    EXCEPTIONS_START,
    EXCEPTIONS_END,
  },

  theme: {
    background: DARK_BLUE_1,
    border: `1px solid transparent`,
    link: BLUE,
    text: LIGHT_GREY,
    linkHover: hover(BLUE),
    color: LIGHT_GREY,

    content: {
      backgroundColor: DARK_BLUE_2,
      color: LIGHT_GREY,
      secondaryColor: LIGHT_GREY_3,
      iconColor: LIGHT_GREY_3,
    },

    CommonNav: {
      background: DARK_BLUE_3,
      color: LIGHT_GREY_2,
      border: "1px solid transparent",
      hover: DARK_BLUE_1,
      popup: {
        background: DARK_BLUE_3,
        color: LIGHT_GREY,
        activeColor: WHITE,
      },
    },

    Alert: {
      color: BLUE,
      backgroundEven: DARK_BLUE_4,
      background: DARK_BLUE_5,
      secondColor: LIGHT_GREY_3,
    },

    Dashboards: {
      color: WHITE,
      active: ORANGE,
      inactiveTab: LIGHT_GREY_4,
      activeTab: ORANGE,
      borderColor: DARK_GREY_1,
      fill: WHITE,
      border: `1px solid ${DARK_GREY_1}`,
    },

    Chart: {
      borderBottom: `1px solid ${DARK_GREY_1}`,
    },

    Radio: {
      checked: {
        backgroundColor: ORANGE,
      },
    },

    TextInput: {
      backgroundColor: LIGHT_GREY_6,
      inactive: LIGHT_GREY_6,
    },

    Label: {
      color: LIGHT_GREY_6,
    },

    SubNav: {
      background: DARK_BLUE_1,
      color: LIGHT_GREY_3,
      backgroundColor: DARK_BLUE_4,
      active: {
        color: ORANGE,
      },
    },

    Button: {
      backgroundColor: PASTEL_BLUE,
      border: `1px solid transparent`,
      color: BLUE,
      hover: {
        backgroundColor: hover(BLUE),
        color: WHITE,
      },
    },

    PrimaryButton: {
      backgroundColor: BLUE,
      color: WHITE,
      hover: {
        backgroundColor: hover(BLUE),
        color: WHITE,
      },
    },

    OptionToggleButton: {
      backgroundColor: DARK_BLUE_1,
    },

    Table: {
      border: `1px solid transparent`,
      borderColor: DARK_GREY_1,
    },

    TableRow: {
      color: LIGHT_GREY_3,
      even: {
        backgroundColor: DARK_BLUE_5,
      },
      odd: {
        backgroundColor: DARK_BLUE_4,
      },
      hover: {
        backgroundColor: PASTEL_BLUE,
      },
    },

    TableHeader: {
      border: `1px solid ${DARK_GREY_1}`,
      backgroundColor: DARK_BLUE_2,
      color: LIGHT_GREY_1,
    },

    TableCell: {
      backgroundColor: "transparent",
      sorted: {
        backgroundColor: DARK_BLUE_2,
      },
    },

    Traces: {
      subHeader: LIGHT_GREY_1,
      breakdownLabelTextColor: WHITE,
      labelTextColor: LIGHT_GREY_1,
      unitColor: LIGHT_GREY,
      percentColor: LIGHT_GREY_1,
      textColor: LIGHT_GREY,
      bannerBackground: DARK_BLUE_2,
      disabledBannerBackground: DARK_BLUE_4,
      disabledBannerBorder: `1px solid ${DARK_BLUE_4}`,
    },
  },
};
